






















import { Component, Vue, Prop, Watch } from 'vue-property-decorator';

@Component
export default class UrlModal extends Vue {
  @Prop({ required: true }) item!: any;
  url: string = '';

  mounted() {
    if (this.item?.url) {
      this.url = this.item.url;
    }
  }

  @Watch('item', { immediate: true, deep: true })
  onItemChange(newItem: any) {
    if (newItem?.url) {
      this.url = newItem.url;
    } else {
      this.url = '';
    }
  }

  onInput(value: string) {
    this.url = value.slice(0, 500);
  }

  saveUrl() {
    this.$emit('addUrl', this.url);
    this.$bvModal.hide('add_url_modal');
  }

  closeModal() {
    this.$bvModal.hide('add_url_modal');
  }
}
